import { ViewState } from 'react-map-gl';
import store from '@Services/redux/Store';
import { IViewState, WorkbenchType } from './Interfaces';
import { WorkbenchActions } from './Reducer';

const Api = {
    setWorkbench: (workbench: WorkbenchType, callback?: () => void) => {
        store.dispatch(WorkbenchActions.setWorkbench(workbench));

        if (callback) {
            callback();
        }
    },
    setViewState: (mapViewState: ViewState) => {
        const vs: IViewState = {
            latitude: mapViewState.latitude,
            longitude: mapViewState.longitude,
            zoom: mapViewState.zoom,
        };
        store.dispatch(WorkbenchActions.setViewState(vs));
    },
};

export default Api;
